import React, { lazy } from 'react';

// A lazy route whose code can load before the first render. Once loaded it
// renders straight away instead of suspending, so React's first commit is the
// real page and the prerendered copy never gives way to the loading screen.
export const preloadableRoute = (load) => {
  let Loaded = null;
  let pending = null;
  const preload = () => {
    if (!pending) {
      pending = load().then((module) => {
        Loaded = module?.default || null;
        return module;
      });
    }
    return pending;
  };
  const Lazy = lazy(preload);
  const Route = (props) => (Loaded ? <Loaded {...props} /> : <Lazy {...props} />);
  Route.preload = preload;
  return Route;
};
